import { ChannelLabel, Option } from './types';

export const YScaleOptions: Option[] = [
  { label: '10 uV', value: 10 },
  { label: '20 uV', value: 5 },
  { label: '50 uV', value: 2 },
  { label: '100 uV', value: 1 },
  { label: '200 uV', value: 0.5 },
  { label: '500 uV', value: 0.2 },
  { label: '1 mV', value: 0.1 },
  { label: '2 mV', value: 0.05 },
  { label: '5 mV', value: 0.02 },
  { label: '10 mV', value: 0.01 },
  { label: '20 mV', value: 0.005 },
  { label: '50 mV', value: 0.002 },
  { label: '100 mV', value: 0.001 },
  { label: '200 mV', value: 0.0005 },
  { label: '500 mV', value: 0.0002 },
];

export const FrequencyMinOptions: Option[] = (() => {
  const options: Option[] = [
    { label: '0.1', value: 0.1 },
    { label: '0.5', value: 0.5 },
  ];
  for (let i = 1; i < 100; i++) {
    options.push({ label: `${i}.0`, value: i });
  }
  return options;
})();

export const FrequencyMaxOptions: Option[] = (() => {
  const options: Option[] = [{ label: '0.5', value: 0.5 }];
  for (let i = 1; i <= 100; i++) {
    options.push({ label: `${i}.0`, value: i });
  }
  return options;
})();

export const XScaleMin = 1;
export const XScaleMax = 15;

export type TechType = 'linked_ears' | 'longitudinal';

export const DEFAULT_X_SCALE = 10;
export const DEFAULT_Y_SCALE = 2;
export const DEFAULT_FREQUENCY = {
  min: 1,
  max: 60,
};

// EEG 관련 상수
export const EEG_CHANNEL_LABELS: ChannelLabel[] = [
  ChannelLabel.O2,
  ChannelLabel.O1,
  ChannelLabel.P4,
  ChannelLabel.Pz,
  ChannelLabel.P3,
  ChannelLabel.C4,
  ChannelLabel.Cz,
  ChannelLabel.C3,
  ChannelLabel.T6,
  ChannelLabel.T5,
  ChannelLabel.T4,
  ChannelLabel.T3,
  ChannelLabel.F8,
  ChannelLabel.F4,
  ChannelLabel.Fz,
  ChannelLabel.F3,
  ChannelLabel.F7,
  ChannelLabel.Fp2,
  ChannelLabel.Fp1,
];

export const EEG_LONGITUDINAL_CHANNEL_LABELS: string[] = [
  `${ChannelLabel.Cz} - ${ChannelLabel.Pz}`,
  `${ChannelLabel.Fz} - ${ChannelLabel.Cz}`,
  ``,
  `${ChannelLabel.P4} - ${ChannelLabel.O2}`,
  `${ChannelLabel.C4} - ${ChannelLabel.P4}`,
  `${ChannelLabel.F4} - ${ChannelLabel.C4}`,
  `${ChannelLabel.Fp2} - ${ChannelLabel.F4}`,
  ``,
  `${ChannelLabel.P3} - ${ChannelLabel.O1}`,
  `${ChannelLabel.C3} - ${ChannelLabel.P3}`,
  `${ChannelLabel.F3} - ${ChannelLabel.C3}`,
  `${ChannelLabel.Fp1} - ${ChannelLabel.F3}`,
  ``,
  `${ChannelLabel.T6} - ${ChannelLabel.O2}`,
  `${ChannelLabel.T4} - ${ChannelLabel.T6}`,
  `${ChannelLabel.F8} - ${ChannelLabel.T4}`,
  `${ChannelLabel.Fp2} - ${ChannelLabel.F8}`,
  ``,
  `${ChannelLabel.T5} - ${ChannelLabel.O1}`,
  `${ChannelLabel.T3} - ${ChannelLabel.T5}`,
  `${ChannelLabel.F7} - ${ChannelLabel.T3}`,
  `${ChannelLabel.Fp1} - ${ChannelLabel.F7}`,
];

export const CHANNEL_TICK_VALUE = 100;

export const PAGE_PER_DATA_LENGTH = 500;
